import axios from "axios";

import { cardMode, serverUrl } from "../_constants";

// Ответ на необязательный чекбокс рассылки в AgreementGate: гейт проходят до
// входа, писать метку на бэк ещё некому, поэтому ответ ждёт на устройстве
// первой успешной авторизации. Значение — "true"/"false", отсутствие ключа
// значит «уже отправлено» (или гейт этой версии ещё не проходили).
const NEWS_CONSENT_KEY = "card_news_consent";

export function saveNewsConsent(agreed) {
  localStorage.setItem(NEWS_CONSENT_KEY, agreed ? "true" : "false");
}

export function hasPendingNewsConsent() {
  return localStorage.getItem(NEWS_CONSENT_KEY) !== null;
}

// Тело для POST api/sign/user-agreement: соглашение ручка подписывает сама, а
// согласие на рассылку добавляется параметром — так в типичном случае (первый
// вход, соглашение ещё не подписано) оба согласия уходят одним запросом.
export function newsConsentBody() {
  const stored = localStorage.getItem(NEWS_CONSENT_KEY);

  return stored === null ? {} : { news_consent: stored === "true" };
}

// Стирать только после успешного ответа: иначе согласие потеряется на первом же
// обрыве связи. Пока ключ на месте, следующий вход попробует отправить снова.
export function clearNewsConsent() {
  localStorage.removeItem(NEWS_CONSENT_KEY);
}

// Досылает согласия, собранные гейтом, после успешного входа: соглашение — если
// аккаунт его ещё не подписывал, рассылку — если ответ лежит на устройстве.
// Отдельный запрос получается только у аккаунта, который соглашение уже подписал
// (например, заведён в вебе), — у остальных всё уходит вместе.
export function flushCardConsents(token, isAgreementAccepted) {
  if (!cardMode) return;
  if (isAgreementAccepted !== false && !hasPendingNewsConsent()) return;

  axios
    .post(`${serverUrl}api/sign/user-agreement`, newsConsentBody(), {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(clearNewsConsent)
    .catch(() => {});
}
